<template lang="pug">
  .height-100
    transition-group.contenedor-box(name="fade-smooth-two", tag="div")
      .box.position-relative(key="reporte_documentos_firmar")
        reporte-documentos-firmar

</template>

<script>
import ComponentReporteDocumentosFirmar from '../components/Component_Reporte_Documentos_Firmar'
export default {
  name: 'view_reporte_cdocumentos_firmar',
  components: {
    'reporte-documentos-firmar': ComponentReporteDocumentosFirmar
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
  .contenedor-box
    display flex
    justify-content center
    flex-direction column
    position relative
    >*
      transition all .5s
      width 100%
</style>



// WEBPACK FOOTER //
// View_Reporte_Documentos_Firmar.vue?c7150204